import { render, staticRenderFns } from "./AdminAddForm.vue?vue&type=template&id=61431e0e&scoped=true&"
import script from "./AdminAddForm.vue?vue&type=script&lang=js&"
export * from "./AdminAddForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddForm.vue?vue&type=style&index=0&id=61431e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61431e0e",
  null
  
)

export default component.exports